export default function TeacherEnterCBT() {
  return (
    <div className="mx-auto max-w-3xl p-6">
      <div className="rounded-2xl border bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">CBT result entry</h1>
        <p className="mt-2 text-slate-500 dark:text-slate-300">CBT is handled by the JAMB/CBT result workflow. The academic broadsheet uses First Test, Second Test and Exam.</p>
      </div>
    </div>
  );
}
